// extracted by mini-css-extract-plugin
export default {"signInButtons":"src-hellospa-page-authentication-sign-in-buttons__signInButtons--RtTpX"};